import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { LogoFull } from "./Logo";
import { useContent, telLink, mailLink } from "../data/siteContent";

export default function Footer() {
  const { contact } = useContent();
  return (
    <footer data-testid="site-footer" className="border-t border-line">
      <div className="mx-auto max-w-7xl px-6 pb-28 pt-14 lg:px-10 lg:pb-16">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <Link to="/" data-testid="footer-logo" aria-label="Allcov home">
            <LogoFull markClassName="h-8 w-auto" textClassName="font-batangas text-3xl tracking-tight" />
          </Link>
          <ul className="flex flex-wrap items-center gap-7 text-xs uppercase tracking-[0.2em]">
            <li><Link data-testid="footer-services-link" className="text-mut transition-colors duration-300 hover:text-pop" to="/services/brand-website">Services</Link></li>
            <li><Link data-testid="footer-pricing-link" className="text-mut transition-colors duration-300 hover:text-pop" to="/pricing">Pricing</Link></li>
            <li><Link data-testid="footer-work-link" className="text-mut transition-colors duration-300 hover:text-pop" to="/work">Work</Link></li>
            <li><Link data-testid="footer-quikpik-link" className="text-mut transition-colors duration-300 hover:text-pop" to="/quikpik">Quikpik</Link></li>
            <li><Link data-testid="footer-about-link" className="text-mut transition-colors duration-300 hover:text-pop" to="/about">About</Link></li>
            <li><Link data-testid="footer-contact-link" className="text-mut transition-colors duration-300 hover:text-pop" to="/contact">Contact</Link></li>
          </ul>
          <div className="flex flex-col gap-2 text-sm text-mut">
            <a data-testid="footer-phone-link" href={telLink({ contact })} className="flex items-center gap-2 transition-colors duration-300 hover:text-pop">
              <Phone size={14} className="text-pop" /> {contact.phone_display}
            </a>
            <a data-testid="footer-email-link" href={mailLink({ contact })} className="flex items-center gap-2 transition-colors duration-300 hover:text-pop">
              <Mail size={14} className="text-pop" /> {contact.email}
            </a>
          </div>
        </div>
        <div className="mt-10 flex flex-wrap gap-x-8 gap-y-2 text-xs text-mut">
          <Link data-testid="footer-privacy-link" to="/privacy-policy" className="transition-colors duration-300 hover:text-pop">Privacy Policy</Link>
          <Link data-testid="footer-terms-link" to="/terms" className="transition-colors duration-300 hover:text-pop">Terms of Service</Link>
          <Link data-testid="footer-refund-link" to="/refund-policy" className="transition-colors duration-300 hover:text-pop">Refund & Cancellation Policy</Link>
        </div>
        <div className="mt-8 flex flex-col gap-2 border-t border-line pt-6 text-xs text-faint">
          <p data-testid="footer-legal-line">ALLCOV LLP · LLPIN ACQ-7779 · GSTIN 09ACLFA1029L1Z9</p>
          <p className="flex items-start gap-2" data-testid="footer-address">
            <MapPin size={13} className="mt-0.5 shrink-0 text-pop" />
            {contact.address}
          </p>
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Allcov LLP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
